import React, { useState, useEffect } from 'react';
import { object, string } from 'prop-types';
import { TableCustom, Loading } from '../../common';
import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage } from '@laramie/ui';
import { APIS } from '../../../config/apis';
import { ServerRequest } from '../../../utils/apiweb';
import { getDateToString, getFormatNumber } from '../../../utils/convert';
import { useReporte } from '../../hooks';
import { OpenObjectURL } from '../../../utils/helpers';
import { isNull } from '../../../utils/validator';

const CuentaRecibosGrid = (props) => {

    //hooks
    const [state, setState] = useState({
        processKey: "",
        idCuenta: 0,
        disabled: false,
        loading: false,
        list: [],
        boletas: []
    });

    const mount = () => {
        if(props.data.idCuenta > 0) {
            setState(prevState => {
                return {...prevState,
                    processKey: props.processKey,
                    idCuenta: props.data.idCuenta
                };
            });

            SearchRecibos(props.data.idCuenta);
            SearchBoletas(props.data.idCuenta);
        }
    }
    useEffect(mount, [props.data.idCuenta]);

    const [ generateReporte ] = useReporte({
        callback: (reporte, buffer, message, filename) => {
            if (buffer)
                OpenObjectURL(filename ?? `${reporte}.pdf`, buffer);
            else
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        }
    });


    // La boleta de la emisión, la misma que se mandó por mail, se ofrece en sus cupones mientras se pueda pagar.
    const tieneBoleta = (row) => !isNull(row.idEmisionEjecucion) && state.boletas.some(f => f.idEmisionEjecucion === row.idEmisionEjecucion);

    const cellVMR = (data) =>  <div className='action'>
                                    {tieneBoleta(data.row.original) &&
                                    <div onClick={ (event) => handleClickBoleta(data.row.original.idEmisionEjecucion) } className="link">
                                        <span className="material-symbols-outlined" title="Descargar boleta">receipt_long</span>
                                    </div>
                                    }
                                    <div onClick={ (event) => handleClickPrint(data.value) } className="link">
                                        <span className="material-symbols-outlined" title="Reimprimir">print</span>
                                    </div>
                                </div>

    const getNumeroRecibo = (props) => {
        const row = props.row.original;
        return `${row.codigoDelegacion}-${row.numeroRecibo.toString().padStart(10,"0")}`;
    }

    const tableColumns = [
        { Header: 'Periodo', accessor: 'periodo', width: '10%', alignCell: 'right' },
        { Header: 'Cuota', accessor: 'cuota', width: '10%', alignCell: 'right' },
        { Header: 'Número', Cell: (props) => getNumeroRecibo(props), id:'numeroRecibo', accessor: 'id', width: '30%', alignCell: 'right' },
        { Header: 'Fecha Vto.', Cell: (props) => getDateToString(props.value, false), accessor: 'fechaVencimiento1Original', width: '15%',  alignCell: 'center' },
        { Header: 'Importe', Cell: (props) => getFormatNumber(props.value,2), accessor: 'importeVencimiento1', width: '15%', alignCell: 'right'},
        { Header: '', Cell: cellVMR, id:'abm', accessor: 'id', width: '5%', disableGlobalFilter: true, disableSortBy: true }
    ];

    //handles
    const handleClickPrint = (idCuentaPago) => {
        PrintRecibo(idCuentaPago);
    }
    const handleClickBoleta = (idEmisionEjecucion) => {
        PrintBoleta(idEmisionEjecucion);
    }
    // funciones
    function PrintRecibo(idCuentaPago) {
        const paramsReporte = {
            idCuentaPago: idCuentaPago
        }
        generateReporte("CuentaCorrienteRecibo", paramsReporte);
    }
    function PrintBoleta(idEmisionEjecucion) {
        const paramsReporte = {
            esBoleta: true,
            idEmisionEjecucion: idEmisionEjecucion,
            idCuenta: state.idCuenta
        }
        generateReporte("EmisionReciboBoleta", paramsReporte);
    }
    function SearchRecibos(idCuenta) {
        setState(prevState => {
            return {...prevState, loading: true};
        });

        const paramsUrl = `/cuenta/${idCuenta}`;

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.CUENTA_PAGO,
            paramsUrl,
            null,
            callbackSuccessRecibos,
            callbackNoSuccess,
            callbackError
        );
    }
    function SearchBoletas(idCuenta) {
        const paramsUrl = `/cuenta/${idCuenta}`;

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.BOLETA_EMISION,
            paramsUrl,
            null,
            callbackSuccessBoletas,
            callbackNoSuccess,
            callbackError
        );
    }
    function RefreshRecibos() {
        SearchRecibos(state.idCuenta);
        SearchBoletas(state.idCuenta);
    }

    //callbacks
    const callbackNoSuccess = (response) => {
        response.json()
        .then((error) => {
            const message = error.message;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        });
    }
    const callbackError = (error) => {
        const message = 'Error procesando solicitud: ' + error.message;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setState(prevState => {
            return {...prevState, loading: false};
        });
    }
    const callbackSuccessRecibos = (response) => {
        response.json()
        .then((data) => {
            data.forEach(row => {
                if (row.fechaVencimiento1Original) row.fechaVencimiento1Original = new Date(row.fechaVencimiento1Original);
                if (row.fechaVencimiento2Original) row.fechaVencimiento2Original = new Date(row.fechaVencimiento2Original);
                if (row.fechaVencimiento1) row.fechaVencimiento1 = new Date(row.fechaVencimiento1);
                if (row.fechaVencimiento2) row.fechaVencimiento2 = new Date(row.fechaVencimiento2);
            });
            data.sort((a,b) => b.id - a.id);
            setState(prevState => {
                return {...prevState, loading: false, list: data};
            });
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        });
    };
    const callbackSuccessBoletas = (response) => {
        response.json()
        .then((data) => {
            setState(prevState => {
                return {...prevState, boletas: data};
            });
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        });
    };

    return (
    <>
        <Loading visible={state.loading}></Loading>

        <TableCustom
            showFilterGlobal={false}
            className={'TableCustomBase'}
            columns={tableColumns}
            // data={ state.list.filter(f => isNull(f.idEmisionEjecucion)) }
            data={ state.list }
        />

        <button id="btnRefreshRecibos" className='invisible' onClick={ (event) => RefreshRecibos() }>Refresh VEPS</button>
    </>
    );
}

CuentaRecibosGrid.propTypes = {
    processKey: string.isRequired,
    data: object.isRequired
};

CuentaRecibosGrid.defaultProps = {};

export default CuentaRecibosGrid;